import { Outlet } from "react-router";
import { FilterProvider } from "../../../context/FilterProvider";

const WSRBSummaryFilter = () => {
    return (
        <FilterProvider>
            <Outlet />
        </FilterProvider>
    );
}

export default WSRBSummaryFilter;
